import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { NavItem } from './header.model';

@Component({
  selector: 'stc-apps-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent {
  @Input() userName: string | undefined;
  @Input() logoSrc: string | undefined;
  @Input() showLang = true;
  @Input() showDelegate = false;
  @Input({ required: true }) sidebarLogoSrc: string | undefined;
  @Output() logOut: EventEmitter<void> = new EventEmitter();
  @Output() delegateUser: EventEmitter<void> = new EventEmitter();
  @Output() backToHome: EventEmitter<void> = new EventEmitter();

  @Input({ required: true })
  allItems!: NavItem[];
  @ViewChild('toggleButton') toggleButton!: ElementRef;
  @ViewChild('menu') menu!: ElementRef;
  constructor(private renderer: Renderer2, private router: Router) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (e.target === this.menu.nativeElement) {
        this.showMenu = false;
      }

      if (e.target !== this.toggleButton.nativeElement) {
        this.showMenu = false;
      }
    });
  }

  showMenu = false;
  toggle(): void {
    this.showMenu = !this.showMenu;
  }

  handleLogout() {
    this.logOut.emit();
  }

  handleUserDelegation() {
    this.delegateUser.emit();
  }

  /**
   * Marks the most specific matching nav URL as active so a parent like
   * `/change-requests` does not stay highlighted on `/change-requests/dashboard`.
   */
  isNavItemActive(item: NavItem): boolean {
    if (!item.url || item.isExtrnal) {
      return false;
    }

    const current = this.router.url.split('?')[0].split('#')[0];
    const itemPath = this.normalizePath(item.url);
    if (!this.pathMatches(current, itemPath)) {
      return false;
    }

    return !(this.allItems || []).some((other) => {
      if (!other.url || other === item || other.isExtrnal) {
        return false;
      }
      const otherPath = this.normalizePath(other.url);
      return (
        otherPath.length > itemPath.length &&
        this.pathMatches(current, otherPath)
      );
    });
  }

  private normalizePath(url: string): string {
    return '/' + String(url || '').replace(/^\/+/, '');
  }

  private pathMatches(current: string, itemPath: string): boolean {
    return current === itemPath || current.startsWith(itemPath + '/');
  }
}
